import { useMemo } from 'react'
import type { ProductBillOfMaterial } from '@ztechapps/common.contract'
import orderBy from 'lodash/orderBy'
import map from 'lodash/map'

export const useSortBillOfMaterials = (billOfMaterials: ProductBillOfMaterial[]) => {
  //sort by the usRequired, then quantityonhand+requiredComputedQuantityOnHand

  return useMemo(() => {
    const mappedValue = map(billOfMaterials, (e) => {
      return {
        ...e,
        requiredToBuild: !!e.requiredToBuild,
      }
    })

    return orderBy(mappedValue, ['requiredToBuild'], ['desc']) as unknown as ProductBillOfMaterial[]
  }, [billOfMaterials])
}
